import React from 'react'
import ReactDOM from 'react-dom/client'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import App from './App'
import './styles.css'

const theme = {
  token: {
    colorPrimary: '#1464f4',
    colorText: '#0b1736',
    colorTextSecondary: '#64748b',
    colorBorder: '#dbe3ef',
    colorBgLayout: '#f4f7fb',
    colorBgContainer: '#ffffff',
    borderRadius: 8,
    fontFamily: 'Inter, "PingFang SC", "Microsoft YaHei", system-ui, sans-serif',
  },
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN} theme={theme}>
      <App />
    </ConfigProvider>
  </React.StrictMode>,
)
